// @ts-nocheck
import { Divider, Tooltip, Typography, styled } from "@mui/material";
import { Box } from "@mui/system";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
import { phoneNumberFormat } from "../../utils/methods/formatters";

export const CustomTooltip = styled((props) => <Tooltip {...props} />)(() => ({
  cursor: "pointer",
}));

export const ClientTool = ({ children, data, disable, placement }) => {
  if (disable || (!data?.email && !data?.phone)) {
    return children;
  }
  return (
    <CustomTooltip
      enterDelay={500}
      arrow
      placement={placement ?? "bottom"}
      title={
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "0.75rem",
            flexDirection: "column",
          }}
        >
          {/* <Typography */}
          {/*   sx={{ */}
          {/*     fontSize: "1.15rem", */}
          {/*     fontWeight: 400, */}
          {/*   }} */}
          {/* > */}
          {/*   Client Information */}
          {/* </Typography> */}
          {/* <Divider */}
          {/*   orientation="horizontal" */}
          {/*   sx={{ borderColor: "#ffffff7d", width: "100%" }} */}
          {/* /> */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "0.25rem",
              flexDirection: "column",
            }}
          >
            {(data?.firstName || data?.lastName) && (
              <Typography
                sx={{
                  "& p": {
                    display: "inline-flex",
                  },
                }}
              >
                <Typography
                  sx={{
                    color: getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    }),
                  }}
                >
                  Name :
                </Typography>{" "}
                <Typography>
                  {data?.firstName || data?.lastName
                    ? data?.firstName + " " + data?.lastName
                    : "N/A"}
                </Typography>
              </Typography>
            )}
            {data?.email && (
              <Typography
                sx={{
                  "& p": {
                    display: "inline-flex",
                  },
                }}
              >
                <Typography
                  sx={{
                    color: getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    }),
                  }}
                >
                  Email :
                </Typography>{" "}
                <Typography>{data?.email ?? "N/A"}</Typography>
              </Typography>
            )}

            {data?.mobile && (
              <Typography
                sx={{
                  "& p": {
                    display: "inline-flex",
                  },
                }}
              >
                <Typography
                  sx={{
                    color: getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    }),
                  }}
                >
                  Mobile :
                </Typography>{" "}
                <Typography>
                  {phoneNumberFormat(data?.mobile) ?? "N/A"}
                </Typography>
              </Typography>
            )}

            {data?.companyName && (
              <Typography
                sx={{
                  "& p": {
                    display: "inline-flex",
                  },
                }}
              >
                <Typography
                  sx={{
                    color: getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    }),
                  }}
                >
                  Company :
                </Typography>{" "}
                <Typography>{data?.companyName ?? "N/A"}</Typography>
              </Typography>
            )}
          </Box>
        </Box>
      }
    >
      <span>{children}</span>
    </CustomTooltip>
  );
};

ClientTool.propTypes = {
  children: PropTypes.any,
  data: PropTypes.object,
  disable: PropTypes.bool,
  placement: PropTypes.string,
};